export enum YesNo {
  "No" = "No",
  "Yes" = "Yes",
}

export enum QuoteTypeEnum {
  "stf" = "stf",
  "rental" = "rental",
  "premier" = "premier",
}

export enum RentalProduct {
  "5/1 ARM" = "5/1 ARM",
  "10/1 ARM" = "10/1 ARM",
  "5 IO 25 ARM" = "5 IO 25 ARM",
  "Fixed" = "Fixed",
  "Rental Bridge" = "Rental Bridge",
}

export enum RentalPremierProduct {
  "Premier - 5 Year, 30 Am" = "Premier - 5 Year, 30 Am",
  "Premier - 10 Year, 30 Am" = "Premier - 10 Year, 30 Am",
  "Premier - 5 Year Balloon" = "Premier - 5 Year Balloon",
  "Premier - 10 Year Balloon" = "Premier - 10 Year Balloon",
  "Premier - 5/1 ARM" = "Premier - 5/1 ARM",
  "Premier - 30 Year Fixed" = "Premier - 30 Year Fixed",
}

export enum FixAndFlipProduct {
  "FixNFlip" = "FixNFlip",
  "BridgePlus" = "BridgePlus",
  "New Construction" = "New Construction",
  "Fix2Rent" = "Fix2Rent",
}

export type UserRole =
  | "External"
  | "Sales"
  | "Broker"
  | "Broker Manager"
  | "Lender Finance"
  | "Lender Finance Manager"
  | "Wholesale"
  | "Wholesale Manager"
  | "Inside Sales"
  | "Inside Sales Manager"
  | "Capital Markets"
  | "POD"
  | "POD Manager"
  | "Business Development"
  | "Business Development Manager"
  | "Production Coordinator"
  | "Operations Analyst"
  | "Sales Assistant"
  | "Administrator";
